import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';
import React, { useMemo } from 'react';
import NodeListMenu from '../../NodeListMenu/NodeListMenu';
import { Pack } from '../../reducer/packVertices';
import { GraphData } from '../../types';
import EntityDrawerHeader from '../EntityDrawerHeader';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    inspectDrawer: {
      width: 400,
      background: theme.palette.common.white,
      boxShadow: `inset 1px 0 ${theme.palette.grey[300]}`,
      position: 'absolute',
      right: 0,
      top: 0,
      bottom: 0,
      display: 'flex',
      flexFlow: 'column',
    },
    subtitle: {
      marginBottom: theme.spacing(2),
    },
    packList: {
      maxHeight: 'initial',
      boxShadow: 'none',
    },
    content: { overflow: 'auto' },
  })
);

interface Props {
  pack: Pack;
  onClose: () => void;
  onSelectNode: (id: string) => void;
  graphData: GraphData;
}
const RelationshipDrawer = ({
  pack,
  onClose,
  graphData,
  onSelectNode,
}: Props) => {
  const graphVertices = useMemo(
    () =>
      graphData.vertices.filter((v) =>
        pack.packedVerticesIds.find((id) => id === v.id)
      ),
    [graphData, pack]
  );

  const classes = useStyles();

  const subtitle = <div className={classes.subtitle}>{pack.type} group</div>;
  return (
    <div className={classes.inspectDrawer}>
      <EntityDrawerHeader
        title={`${pack.type} X ${pack.packedVerticesIds.length}`}
        subtitle={subtitle}
        onClose={onClose}
      />
      <div className={classes.content}>
        <NodeListMenu
          open={true}
          onSelectNode={onSelectNode}
          vertices={graphVertices}
          classes={{ paper: classes.packList }}
        />
      </div>
    </div>
  );
};

export default RelationshipDrawer;
